import SvgCheckSolid from "./SvgCheckSolid";
import SvgXmarkSolid from "./SvgXmarkSolid";
import {PackageGridItemProps} from "../models/PropsInterface";


const PackageGridItem = (props: PackageGridItemProps) => {

    return (
        <div className={`services-package__row package_grid_item__row services-package__justify-content-center`}>
            <div className={`services-package__col-9`}>
                <p className={`services-package__mb-0 services-package__mt-1 services-package__pb-0 services-package__fw-bold package_grid_item__font_size_title`}>{props.title}</p>
                <p className={`services-package__mt-1 services-package__mb-0 package_grid_item__font_size_desc`}>{props.desc} </p>
            </div>

            <div className={`services-package__col-3 services-package__p-0 package_grid_item__centered_text_grid_item`}>
                <div className={`services-package__flex-grow-1`}>
                    {
                        (['Yes', 'No'].includes(props.pillText)) ?
                            (props.pillText === 'No' ? <SvgXmarkSolid/> : <SvgCheckSolid/>)
                            : ''
                    }
                    {
                        ['Yes', 'No'].includes(props.pillText) ? '' : props.pillText
                    }
                </div>
            </div>

            <div className={`services-package__col-12 services-package__p-0`}>
                <div className={`package_grid_item__line_style`}/>
            </div>
        </div>
    )
}

export default PackageGridItem